import React from 'react';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';

import { Container, Title } from 'common/components/Layout/Layout';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import styles from './InformationClause.module.scss';

const InformationClause = () => {
  const { content } = ContentStore;

  if (!ContentStore.isLoaded) {
    return null;
  }

  return (
    <div>
      <InjectMetaTags {...content.InformationClauseSEO} />
      <Container>
        <Title title={content.InformationClauseHeader} />
        <div
          className={styles.Content}
          dangerouslySetInnerHTML={{ __html: content.InformationClauseText }}
        />
      </Container>
    </div>
  );
};

export default observer(InformationClause);



// WEBPACK FOOTER //
// ./src/views/InformationClause/InformationClause.js